import { API, Auth } from "aws-amplify";
import { takeEvery, call, put, all } from "redux-saga/effects";
import * as shootTypes from "../constants/ShootActionTypes";
import * as photoShotTypes from "../constants/PhotoShotsActionsTypes";
import * as videoShotTypes from "../constants/VideoShotsActionTypes";
import * as shootService from "../../services/shootService";

const getShoots = async id => {
  let session = await Auth.currentSession();
  let token = session.getIdToken().getJwtToken();
  return API.get("multimedia-checklist", `/shooter/${id}`, {
    headers: {
      Authorization: token
    }
  });
  // console.log(shoots);
};

export function* fetchShoots(action) {
  try {
    const data = yield call(getShoots, action.id);
    console.log(data);
    yield put({ type: shootTypes.DONE_FETCHING_SHOOTS, data });
  } catch (err) {
    yield put({ type: shootTypes.FAILED_FETCHING_SHOOTS });
    console.log(err);
  }
}

export function* getSelectedShoot(action) {
  try {
    console.time("shoot details");
    let { clinic, date } = action;
    let { data } = yield call(
      shootService.getOneShoot,
      {
        clinic,
        created_at: date
      },
      {
        params: {
          type: "details"
        }
      }
    );
    // let photoShots = shootService.getShootShots(
    //   { clinic, created_at: date },
    //   {
    //     params: {
    //       shot_type: "photo"
    //     }
    //   }
    // );
    // let videoShots = shootService.getShootShots(
    //   { clinic, created_at: date },
    //   {
    //     params: {
    //       shot_type: "video"
    //     }
    //   }
    // );

    yield console.log(data);
    yield put({
      type: photoShotTypes.PHOTO_SHOT_FETCHING,
      clinic,
      date
    });

    yield put({
      type: videoShotTypes.VIDEO_SHOT_FETCHING,
      clinic,
      date
    });

    // let [photo, video] = yield all([photoShots, videoShots]);
    // console.log(photo, video);
    // photo = photo.data;
    // video = video.data;
    let { shoot } = data;
    yield console.log(data);

    if (data.photo > 0 && data.video > 0) {
      //all tabs
      console.log("all Tabs");
      shoot.tabType = "ALL";
    } else if (data.photo > 0) {
      //just photo and other
      console.log("photo and other");
      shoot.tabType = "PHOTO";
    } else if (data.video > 0) {
      //just video interview and other
      console.log("video interview and other");
      shoot.tabType = "VIDEO";
    } else {
      //all tabs
      console.log("none");
      shoot.tabType = "ALL";
    }
    yield put({
      type: shootTypes.SHOOT_DONE_FETCHING_SELECTED,
      shoot
    });
    console.timeEnd("shoot details");
  } catch (err) {}
}

function* watchFetchShoot() {
  yield takeEvery(shootTypes.FETCHING_SHOOTS, fetchShoots);
}

function* watchGetSelectedShoot() {
  yield takeEvery(shootTypes.SHOOT_GET_SELECTED, getSelectedShoot);
}

export default {
  watchFetchShoot,
  watchGetSelectedShoot
};
